import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { skuit } from 'src/services/skuit'

import { FoundListTable } from 'src/components/Table/list/Found'
import { ListPage } from 'src/components/Pages/ListPage'

export const FoundListPage = () => {
  const paginator = useQueryPaginator('found-list', skuit.sc.found.list)

  const exportFields = [
    'client_guid',
    'client_name',
    'container_guid',
    'container_name',
    'facility_guid',
    'facility_name',
    'guid',
    'num_units',
    'path',
    'place_guid',
    'place_name',
    'product_guid',
    'product_name',
    'sku_guid',
    'sku_name',
  ]

  return (
    <ListPage
      title='Found'
      paginator={paginator}
    >
      <FoundListTable
        paginator={paginator}
        fields={['sku', 'client', 'product', 'batch', 'numUnits', 'path']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.found.export
        }}
      />
    </ListPage>
  )
}
